































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  DefaultScreenSaver,
  FallbackScreenSaver,
  ScreenSaverType,
  ScreenSaverData,
} from '@/app/shared/utilities/static-types';
import { getScreenSaverService } from '@adminSchedules/shared/actions';

@Component({
  name: 'DeleteScreenSaver',
})
export default class DeleteScreenSaver extends Vue {
  @Prop() public screenSaver!: ScreenSaverData;
  @Prop() public screenSaverType!: ScreenSaverType;
  public closeEvent = 'update:showDeleteScreenSaver';
  public loading = false;

  public get isFallbackScreenSaver(): boolean {
    return this.screenSaverType === ScreenSaverType.FALLBACK_SCREEN_SAVER;
  }

  public get confirmationMessage(): string {
    if (this.isFallbackScreenSaver) {
      return this.$t('confirm_delete_fallback_screen_saver').toString();
    }
    return this.$t('confirm_delete_screen_saver').toString();
  }

  public async deleteScreenSaver() {
    try {
      this.loading = true;
      const service = getScreenSaverService(this.screenSaverType);
      await service.deleteScreenSaverAndReorder(this.screenSaver as any);
      this.$emit('screen-saver-deleted');
      this.$emit(this.closeEvent, false);
    } finally {
      this.loading = false;
    }
  }
}
